import _ from 'lodash';
import moment from 'moment';

function useManualQuoteStatus({ scheduleEvent }) {
    const showStatus = {
        authorized: true,
        cancelled: true,
        priced: true,
        rescheduled: true,
        rejected: true,
    };

    return Boolean(_.get(showStatus, _.get(scheduleEvent, 'schedule.manualquote.status')));
}

function isScheduleEventOverdue({ scheduleEvent }) {
    return (
        scheduleEvent.status === 'scheduled' &&
        moment(scheduleEvent.ends_at)
            .startOf('day')
            .isBefore(moment().startOf('day'))
    );
}

function getScheduleEventStatus({ scheduleEvent }) {
    if (!scheduleEvent) {
        return null;
    }
    let derivedStatus = '';
    if (useManualQuoteStatus({ scheduleEvent })) {
        derivedStatus = _.get(scheduleEvent, 'schedule.manualquote.status');
    } else if (isScheduleEventOverdue({ scheduleEvent })) {
        derivedStatus = 'overdue';
    } else {
        derivedStatus = scheduleEvent.status;
    }

    return derivedStatus;
}

function getScheduleEventType({ scheduleEvent }) {
    if (!scheduleEvent) {
        return null;
    }
    let derivedType = '';
    if (_.get(scheduleEvent, 'schedule.service.str_id') === 'mowing') {
        derivedType = 'mowing';
    } else {
        derivedType = _.get(scheduleEvent, 'schedule.type');
    }

    return derivedType;
}

// eslint-disable-next-line import/prefer-default-export
export const lsScheduleEventHelpers = {
    _private: {
        useManualQuoteStatus,
        isScheduleEventOverdue,
    },
    getScheduleEventStatus,
    getScheduleEventType,
};
